export enum CertificateOrientation {
	Landscape = 'L',
	Portrait = 'P',
}